import { useAuthStore } from "../store/auth.store";

const HeaderBar = () => {
  const user = useAuthStore((state) => state.user);

  return (
    <header className="h-14 bg-slate-900/60 border-b border-white/10 flex items-center justify-end px-6">
      <div className="text-sm text-slate-300">
        {user?.email || "—"}
      </div>
    </header>
  );
};

export default HeaderBar;
